import { Suspense } from 'react';
import { Route } from 'react-router-dom';
import { RedirectToSingleViewRoute } from 'utils/constants/app/general';
import { lazy as lazyImport } from 'utils/generic/lazy';
import { getMountPath } from 'utils/generic/route-manipulation';
import { useSbRouteMatch } from 'newhooks/generic/useSbRouteMatch';

const { RedirectToSingleGameViewContent } = lazyImport(
  () =>
    import(
      /* webpackChunkName: "redirection-to-single-game-view" */ './RedirectToSingleGameView'
    )
);

export const RedirectToSingleGameView = () => {
  const { path } = useSbRouteMatch();

  return (
    <Route
      path={`${getMountPath(path)}${`/(${RedirectToSingleViewRoute})/:game`}`}
    >
      <Suspense fallback={null}>
        <RedirectToSingleGameViewContent />
      </Suspense>
    </Route>
  );
};
